module.exports = __webpack_public_path__ + "static/media/S (37).bfff0b43.jpg";